// URLs which don't need AUTH header
export const whiteListUrls = [
  '/api/sendOtp',
  '/api/verifyOtp',
  '/api/refreshToken',
];
